import * as R from 'ramda';
import { fromJS } from 'immutable';
import * as marketAreaActions from '../actions/marketArea';
import { SUCCESS, START, ERROR } from '../actions/global';
import { fetchingState } from '@constants';

const initialState = {
  allMarketArea: {
    data: [],
    total: 0,
    state: null,
    updateState: null,
    sortModel: [],
  },
  marketArea: { data: {}, state: null },
  marketAreaDetail: { data: {}, state: null },
  marketAreaDetailFiles: {},
  marketAreaDetails: { data: [], state: null },
  marketAreaFiles: {},
  filterCriteria: {
    selectedYear: 'All'
  }
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case marketAreaActions.FETCH_ALL_MARKET_AREA[START]:
      return state.setIn(['allMarketArea', 'state'], fetchingState.FETCHING);
    case marketAreaActions.FETCH_ALL_MARKET_AREA[SUCCESS]:
      return state
        .setIn(
          ['allMarketArea', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        )
        .setIn(
          ['allMarketArea', 'total'],
          fromJS(
            R.pathOr(
              [],
              ['data', 'totalMarketArea', 'marketAreaCount'],
              action,
            ),
          ),
        )
        .setIn(['allMarketArea', 'state'], fetchingState.LOADED);
    case marketAreaActions.FETCH_ALL_MARKET_AREA[ERROR]:
      return state.setIn(['allMarketArea', 'state'], fetchingState.ERROR);
    case marketAreaActions.RESET_ALL_MARKET_AREA:
      return state
        .setIn(['allMarketArea', 'data'], fromJS([]))
        .setIn(['allMarketArea', 'total'], fromJS(0));

    case marketAreaActions.FETCH_MARKET_AREA[START]:
      return state.setIn(['marketArea', 'state'], fetchingState.FETCHING);
    case marketAreaActions.FETCH_MARKET_AREA[SUCCESS]:
      return state
        .setIn(
          ['marketArea', 'data'],
          fromJS(R.pathOr([{}], ['data', 'results'], action)[0]),
        )
        .setIn(['marketArea', 'state'], fetchingState.LOADED);
    case marketAreaActions.FETCH_MARKET_AREA[ERROR]:
      return state.setIn(['marketArea', 'state'], fetchingState.ERROR);
    case marketAreaActions.RESET_MARKET_AREA:
      return state
        .setIn(['marketArea', 'data'], fromJS({}))
        .setIn(['marketArea', 'state'], null);

    case marketAreaActions.UPDATE_MARKET_AREA[START]:
      return state.setIn(['marketArea', 'state'], fetchingState.FETCHING);
    case marketAreaActions.UPDATE_MARKET_AREA[SUCCESS]:
      return state
        .setIn(
          ['marketArea', 'data'],
          fromJS(R.pathOr([{}], ['data', 'results'], action)[0]),
        )
        .setIn(['marketArea', 'state'], fetchingState.LOADED);
    case marketAreaActions.UPDATE_MARKET_AREA[ERROR]:
      return state.setIn(['marketArea', 'state'], fetchingState.ERROR);

    case marketAreaActions.FETCH_MARKET_AREA_DETAILS[START]:
      return state.setIn(
        ['marketAreaDetails', 'state'],
        fetchingState.FETCHING,
      );
    case marketAreaActions.FETCH_MARKET_AREA_DETAILS[SUCCESS]:
      return state
        .setIn(
          ['marketAreaDetails', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        )
        .setIn(['marketAreaDetails', 'state'], fetchingState.LOADED);
    case marketAreaActions.FETCH_MARKET_AREA_DETAILS[ERROR]:
      return state.setIn(['marketAreaDetails', 'state'], fetchingState.ERROR);

    case marketAreaActions.INSERT_MARKET_AREA_FILE[START]: {
      return state.setIn(['marketAreaFiles', 'state'], fetchingState.FETCHING);
    }
    case marketAreaActions.INSERT_MARKET_AREA_FILE[SUCCESS]: {
      return state.setIn(['marketAreaFiles', 'state'], fetchingState.LOADED);
    }
    case marketAreaActions.INSERT_MARKET_AREA_FILE[ERROR]: {
      return state.setIn(['marketAreaFiles', 'state'], fetchingState.ERROR);
    }

    case marketAreaActions.DELETE_MARKET_AREA_FILE[START]: {
      return state.setIn(['marketAreaFiles', 'state'], fetchingState.FETCHING);
    }
    case marketAreaActions.DELETE_MARKET_AREA_FILE[SUCCESS]: {
      return state.setIn(['marketAreaFiles', 'state'], fetchingState.LOADED);
    }
    case marketAreaActions.DELETE_MARKET_AREA_FILE[ERROR]: {
      return state.setIn(['marketAreaFiles', 'state'], fetchingState.ERROR);
    }
    case marketAreaActions.UPDATE_MARKET_AREA_FILE[START]: {
      return state.setIn(['marketAreaFiles', 'state'], fetchingState.FETCHING);
    }
    case marketAreaActions.UPDATE_MARKET_AREA_FILE[SUCCESS]: {
      return state.setIn(['marketAreaFiles', 'state'], fetchingState.LOADED);
    }
    case marketAreaActions.UPDATE_MARKET_AREA_FILE[ERROR]: {
      return state.setIn(['marketAreaFiles', 'state'], fetchingState.ERROR);
    }
    case marketAreaActions.FETCH_MARKET_AREA_DETAIL[START]:
      return state.setIn(['marketAreaDetail', 'state'], fetchingState.FETCHING);
    case marketAreaActions.FETCH_MARKET_AREA_DETAIL[SUCCESS]:
      return state
        .setIn(
          ['marketAreaDetail', 'data'],
          fromJS(R.pathOr([{}], ['data', 'results'], action)[0]),
        )
        .setIn(['marketAreaDetail', 'state'], fetchingState.LOADED);
    case marketAreaActions.FETCH_MARKET_AREA_DETAIL[ERROR]:
      return state.setIn(['marketAreaDetail', 'state'], fetchingState.ERROR);

    case marketAreaActions.UPDATE_MARKET_AREA_DETAIL[START]:
      return state.setIn(['marketAreaDetail', 'state'], fetchingState.FETCHING);
    case marketAreaActions.UPDATE_MARKET_AREA_DETAIL[SUCCESS]:
      return state
        .setIn(
          ['marketAreaDetail', 'data'],
          fromJS(R.pathOr([{}], ['data', 'results'], action)[0]),
        )
        .setIn(['marketAreaDetail', 'state'], fetchingState.LOADED);
    case marketAreaActions.UPDATE_MARKET_AREA_DETAIL[ERROR]:
      return state.setIn(['marketAreaDetail', 'state'], fetchingState.ERROR);

    case marketAreaActions.INSERT_MARKET_AREA_DETAIL_FILE[START]: {
      return state.setIn(
        ['marketAreaDetailFiles', 'state'],
        fetchingState.FETCHING,
      );
    }
    case marketAreaActions.INSERT_MARKET_AREA_DETAIL_FILE[SUCCESS]: {
      return state.setIn(
        ['marketAreaDetailFiles', 'state'],
        fetchingState.LOADED,
      );
    }
    case marketAreaActions.INSERT_MARKET_AREA_DETAIL_FILE[ERROR]: {
      return state.setIn(
        ['marketAreaDetailFiles', 'state'],
        fetchingState.ERROR,
      );
    }

    case marketAreaActions.DELETE_MARKET_AREA_DETAIL_FILE[START]: {
      return state.setIn(
        ['marketAreaDetailFiles', 'state'],
        fetchingState.FETCHING,
      );
    }
    case marketAreaActions.DELETE_MARKET_AREA_DETAIL_FILE[SUCCESS]: {
      return state.setIn(
        ['marketAreaDetailFiles', 'state'],
        fetchingState.LOADED,
      );
    }
    case marketAreaActions.DELETE_MARKET_AREA_DETAIL_FILE[ERROR]: {
      return state.setIn(
        ['marketAreaDetailFiles', 'state'],
        fetchingState.ERROR,
      );
    }
    case marketAreaActions.UPDATE_MARKET_AREA_DETAIL_FILE[START]: {
      return state.setIn(
        ['marketAreaDetailFiles', 'state'],
        fetchingState.FETCHING,
      );
    }
    case marketAreaActions.UPDATE_MARKET_AREA_DETAIL_FILE[SUCCESS]: {
      return state.setIn(
        ['marketAreaDetailFiles', 'state'],
        fetchingState.LOADED,
      );
    }
    case marketAreaActions.UPDATE_MARKET_AREA_DETAIL_FILE[ERROR]: {
      return state.setIn(
        ['marketAreaDetailFiles', 'state'],
        fetchingState.ERROR,
      );
    }

    case marketAreaActions.CHANGE_SORT_MODEL: {
      return state.setIn(
        ['allMarketArea', 'sortModel'],
        fromJS(action.payload),
      );
    }
    case marketAreaActions.SET_MARKET_AREA_YEAR_FILTER: {
      return state.setIn(
        ['filterCriteria', 'selectedYear'],
        fromJS(action.payload),
      );
    }

    default:
      return state;
  }
};
